export function waitForElm(selector) {
	return new Promise(resolve => {
		if (document.querySelector(selector)) {
			return resolve(document.querySelector(selector));
		}

		const observer = new MutationObserver(mutations => {
			if (document.querySelector(selector)) {
				resolve(document.querySelector(selector));
				observer.disconnect();
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
	});
}


export function waitForElmDel(selector) {
	return new Promise(resolve => {
		if (!document.querySelector(selector)) {
			return resolve(selector);
		}

		const observer = new MutationObserver(mutations => {
			for (const mutation of mutations) {
				for (const removedNode of mutation.removedNodes) {
					if (removedNode.classList) {
						//if (removedNode.id === selector) {
						if (removedNode.classList.contains("modal")) {
							resolve(selector);
							observer.disconnect();
						}
					}
				}
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
	});
}

export function recreateNode(el, withChildren) {
	if (withChildren) {
		el.parentNode.replaceChild(el.cloneNode(true), el);
	}
	else {
		var newEl = el.cloneNode(false);
		while (el.hasChildNodes()) newEl.appendChild(el.firstChild);
		el.parentNode.replaceChild(newEl, el);
	}
}

export function disableButtonsByClass(className) {
        const buttons = document.querySelectorAll(`.${className}`);
        buttons.forEach(button => {
                button.disabled = true;
        });
}

// Function to enable all buttons with a specific class
export function enableButtonsByClass(className) {
        const buttons = document.querySelectorAll(`.${className}`);
        buttons.forEach(button => {
                button.disabled = false;
        });
}

export function addQueryParam(url, key, value) {
        const separator = url.includes('?') ? '&' : '?';
        return url + separator + key + '=' + encodeURIComponent(value);
}

export function fivedigit() {
        return Math.floor(Math.random() * 90000) + 10000;
}

export function areArraysEqual(arr1, arr2) {
        if (arr1.length !== arr2.length) {
                return false;
        }

        return arr1.every((value, index) => value === arr2[index]);
}
